import { ITheme } from '../api/Data'
import { getProjectCopyDefaults } from '../config/projectCopyDefaults'
import { getProjectWorkflowDefaults, ProjectType } from '../config/projectTypes'

interface ProjectCreationOptions {
  projectName: string
  projectType: ProjectType
  teamName: string
  theme: ITheme
}

export const buildProjectCreationPayload = ({ projectName, projectType, teamName, theme }: ProjectCreationOptions) => {
  const copyDefaults = getProjectCopyDefaults(projectType, teamName, projectName)

  return {
    name: projectName,
    locale: 'en-US',
    projectType,
    ...getProjectWorkflowDefaults(projectType),
    description: copyDefaults.description,
    rules: copyDefaults.rules,
    tips: copyDefaults.tips,
    ...(copyDefaults.questions
      ? {
          numberOfQuestions: copyDefaults.questions.length,
          questions: copyDefaults.questions,
        }
      : {}),
    displaySetting: {
      showLocation: false,
    },
    themeId: theme.id,
  }
}
